<!-- 图表切换tab -->
<template>
  <div v-if="!$isEmpty(tabList)" class="hold-tab-switch">
    <div
      v-for="(item, index) in tabList"
      :key="index"
      :class="index === curIndex ? ['tab-item', 'cur-item'] : ['tab-item']"
      @click="clickItem(item, index)"
      >{{item.name}}</div>
  </div>
</template>

<script>
export default {
  name: 'hold-tab-switch',

  props: {
    curIndex: {
      type: Number,
      default: 0,
    },
    tabList: {
      type: Array,
      default: () => ([]),
    },
  },

  methods: {
    clickItem(item, index) {
      this.$emit('clickTab', { ...item, index });
    },
  },
};
</script>

<style lang="less" scoped>
.hold-tab-switch {
  background-color: #f5f5f5;
  padding: 3px;
  width: 438px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .tab-item {
    font-size: 28px;
    color: #000000;
    line-height: 50px;
    text-align: center;
    flex: 1;
    height: 50px;
    background-color: rgba(255, 255, 255, 0);
    border-radius: 8px;
  }
  .cur-item {
    background-color: #ffffff;
    color: #333333;
  }
}
</style>
